export enum FrequencyType {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY'
}

export enum WeekDay {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 7
}

export type CalendarSelection = {
  frequencyType: FrequencyType
  value: number // For monthly: day of month (1-31), for weekly: day of week (1-7), for daily: interval (1-7)
}

export type Day = {
  day: number
  nextSipDate: number
  whyNotDate?: number
}
